import React from "react";
import {
  container,
  contentText,
  disclaimer,
  downloadButton,
  heading,
  image,
  subheading,
} from "@/components/free-resources/styles/social-media-marketing-guide";
import CustomLink from "@/components/custom-link";
import { useTranslation } from "react-i18next";
import { PromoEaster } from "../promo-easter/promo-easter";
import classNames from "classnames";

const SocialMediaMarketingGuide: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={"bg-gray-200 relative"}>
      <div className={disclaimer}>
        <p>{t("free-resources.disclaimer")}</p>
      </div>
      <div
        className={classNames(container, "relative")}
        title={t("free-resources.marketing.seo.title")}
        aria-label={t("free-resources.marketing.seo.aria-label")}
      >
        <PromoEaster day={4} />
        <div className={image}>
          <img
            alt={"marketing guide image"}
            src={"/assets/free-resources/marketing/marketing-guide.svg"}
          />
        </div>

        <div className={contentText}>
          <p className={heading}>{t("free-resources.marketing.heading")}</p>
          <p className={subheading}>
            {t("free-resources.marketing.subheading")}
          </p>
          <CustomLink
            url={
              "/assets/free-resources/marketing/CUS-hearX-Group-free-SM-Marketing-Guide-compressed.pdf"
            }
          >
            <button type={"button"} className={downloadButton}>
              {t("free-resources.marketing.button")}
            </button>
          </CustomLink>
        </div>
      </div>
    </div>
  );
};

export default SocialMediaMarketingGuide;
